module.exports = __webpack_public_path__ + "img/footer_mirror.1c49965c.png";